import { render, staticRenderFns } from "./slider-review-item.vue?vue&type=template&id=48c349a2&scoped=true&"
import script from "./slider-review-item.vue?vue&type=script&lang=js&"
export * from "./slider-review-item.vue?vue&type=script&lang=js&"
import style0 from "./slider-review-item.vue?vue&type=style&index=0&id=48c349a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c349a2",
  null
  
)

export default component.exports